export const getBaseUrl = (isEditorX: boolean) => (isEditorX ? 'https://manage.editorx.com' : 'https://www.wix.com');
